import AddRowIcon from "./add-row-icon.svg";
import AdminGearIcon from "./admin-gear-icon.svg";
import AllEventIcon from "./all-event-icon.svg";
import ArrowLeftIcon from "./arrow-left-icon.svg";
import BackwardIcon from "./backward-icon.svg";
import ButtonIconPlus from "./buttonicon-plus.svg";
import CameraEventSpecCamera from "./camera-eventspec-camera.svg";
import CameraEventSpecDriver from "./camera-eventspec-driver.svg";
import CameraEventSpecExpiry from "./camera-eventspec-expiry.svg";
import CameraEventSpecLocation from "./camera-eventspec-location.svg";
import CallLogsIcon from "./history-rounded-icon.svg";
import ChartIcon from "./chart-icon.svg";
import ChartTypeDOUGHNUT from "./chart-type-DOUGHNUT.svg";
import ChartTypeHORIZONTAL_BAR_GRAPH from "./chart-type-HORIZONTAL_BAR_GRAPH.svg";
import ChartTypeLINE_GRAPH from "./chart-type-LINE_GRAPH.svg";
import ChartTypePIE from "./chart-type-PIE.svg";
import ChartTypeSTACKED_BAR_GRAPH from "./chart-type-STACKED_BAR_GRAPH.svg";
import ChartTypeVERTICAL_BAR_GRAPH from "./chart-type-VERTICAL_BAR_GRAPH.svg";
import ChatAttachmentIcon from "./chat-attachment-icon.svg";
import ChatEmojiIcon from "./chat-emoji-icon.svg";
import ChatIcon from "./chat-icon.svg";
import ChatImageIcon from "./chat-image-icon.svg";
import CheckboxChecked from "./checkbox-checked.svg";
import Checkbox from "./checkbox.svg";
import CheckedIcon from "./checked-icon.svg";
import ChevronDown from "./chevron-down.svg";
import ChevronRightBlue from "./chevron-right-blue.svg";
import ChevronRight from "./chevron-right.svg";
import CloseIcon from "./close-icon.svg";
import CloseIconGray from "./close-icon-gray.svg";
import CollapseIcon from "./collapse-icon.svg";
import ColFilterIcon from "./column-filter-icon.svg";
import ComplianceIcon from "./compliance-icon.svg";
import ConfigurationIcon from "./setting-config-icon.svg";
import CrossRedIcon from "./cross-red-icon.svg";
import Delete from "./delete.svg";
import Document from "./document.svg";
import Download from "./download.svg";
import DragHandleBars from "./drag-handle-bars.svg";
import EditIcon from "./edit-icon.svg";
import EndLocation from "./end-location.svg";
import Error from "./error.svg";
import ExpandIcon from "./expand-icon.svg";
import ExpandMoreIcon from "./expand-more-icon.svg";
import ExpandWindowIcon from "./expand-window-icon.svg";
import EyeOpen from "./eye-open.svg";
import FastBackwardIcon from "./fast-backward-icon.svg";
import FastForwardIcon from "./fast-forward-icon.svg";
import FilterIcon from "./filter-icon.svg";
import ForwardIcon from "./forward-icon.svg";
import FullScreenIcon from "./fullscreen.svg";
import GroupChatIcon from "./group-chat-icon.svg";
import GroupFilterIcon from "./group-filter-icon.svg";
import HamburgerIcon from "./hamburger-icon.svg";
import HandIcon from "./hand-icon.svg";
import heatmapRouteClickIconAsString from "./heatmapRouteClickIconAsString.svg";
import HelpIcon from "./help-icon.svg";
import HideColumnIcon from "./hide-column.svg";
import HidePasswordIcon from "./hide-password-icon.svg";
import Hooter from "./hooter.svg";
import Info from "./info.svg";
import LeftArrowIcon from "./left-arrow-icon.svg";
import LineStyleIcon from "./line-style-icon.svg";
import LineStyleIconDefault from "./line-style-icon-default.svg";
import LineStyleIconP2P from "./line-style-icon-p2p.svg";
import LineStyleIconSnap from "./line-style-icon-snap.svg";
import LineStyleIconDirSvc from "./line-style-icon-dirsvc.svg";
import LinkIcon from "./link-icon.svg";
import LiveViewIcon from "./video-icon.svg";
import Loading from "./loading.svg";
import LoadingAnimation from "./loadingAnimation.svg";
import LockIcon from "./lock-icon.svg";
import Logo from "./logo-fleettrack.svg";
import MagnifierIcon from "./magnifier-icon.svg";
import MapLayersIcon from "./map-layers.svg";
import MapMarkerBlue from "./map-marker-blue.svg";
import MapMarkerRed from "./map-marker-red.svg";
import MinimizeIcon from "./minimize-icon.svg";
import MinusBlue from "./minus-blue.svg";
import MoreVertBlack from "./more-vert-black.svg";
import MoreVertBlue from "./more-vert-blue.svg";
import NotificationIcon from "./notification-icon.svg";
import PlayO from "./play-o.svg";
import PlusBlue from "./plus-blue.svg";
import PrintIcon from "./print-icon.svg";
import RefreshIcon from "./refresh-icon.svg";
import RightArrowIcon from "./right-arrow-icon.svg";
import RightArrowIcon2 from "./right-arrow-icon-2.svg";
import RouteEndIconAsString from "./routeEnd.svg";
import RouteStartIconAsString from "./routeStart.svg";
import SearchIcon from "./search-icon.svg";
import SendChatMessageIcon from "./send-chat-message-icon.svg";
import SettingIcon from "./setting-icon.svg";
import SharedExt from "./shared-ext.svg";
import ShowImageIcon from "./show-image-icon.svg";
import ShowImageIconBlue from "./show-image-icon-blue.svg";
import ShowPasswordIcon from "./show-password-icon.svg";
import SMSIcon from "./sms-icon.svg";
import SortColumnsIcon from "./sort-columns-icon.svg";
import SortIcon from "./sort-icon.svg";
import StarFilledBlue from "./star-filled-blue.svg";
import StarOutline from "./star-outline.svg";
import StartLocation from "./start-location.svg";
import Success from "./success.svg";
import SummationIcon from "./summation-icon.svg";
import TimerIcon from "./timer.svg";
import UnknownTripLocation from "./unknown-trip-location.svg";
import UpdatesLive from "./updates-live.svg";
import UpdatesPaused from "./updates-paused.svg";
import Upload from "./upload.svg";
import UsersIcon from "./users-icon.svg";
import VideoCameraIcon from "./video-camera-icon.svg";
import VideoPlayButton from "./video-play-button.svg";
import VoiceCallIcon from "./phone-icon.svg";
import WarningIcon from "./warning-icon.svg";
import Warning from "./warning.svg";
import PlayButton from "./play-button.svg";
import RightArrowGrey from "./right-arrow-grey.svg";
import HelpCenterIcon from "./help-center-icon.svg";
import DetailedHelCenterIcon from "./detailed-help-guide.svg";
import PhFireTruck from "./vehicle-icons/ph_fire-truck-fill.svg";
import HugeTanker from "./vehicle-icons/hugeicons_tanker-truck.svg";
import HugeTruckMonster from "./vehicle-icons/hugeicons_truck-monster.svg";
import RiTruck from "./vehicle-icons/ri_truck-fill.svg";
import ForkliftTruck from "./vehicle-icons/Forklift Truck.svg";
import Excavator from "./vehicle-icons/Excavator.svg";
import Van from "./vehicle-icons/Van.svg";
import PickupTruck from "./vehicle-icons/Pickup Truck.svg";
import Trailer from "./vehicle-icons/Trailer.svg";
import SanitationTruck from "./vehicle-icons/Sanitation Truck.svg";
import EV from "./vehicle-icons/EV.svg";
import Tractor from "./vehicle-icons/Tractor.svg";
import TowTruck from "./vehicle-icons/Tow Truck.svg";
import SkidSteer from "./vehicle-icons/Skid Steer.svg";
import ConcreteTruck from "./vehicle-icons/Concrete truck.svg";
import BusFront from "./vehicle-icons/Bus front.svg";
import BusSide from "./vehicle-icons/Bus side.svg";
import CarSide from "./vehicle-icons/Car Side.svg";
import CarFront from "./vehicle-icons/Car Front.svg";
import Backhoe from "./vehicle-icons/Backhoe 1.svg";
import BucketTruckOpen from "./vehicle-icons/Bucket Truck open.svg";
import BucketTruckClosed from "./vehicle-icons/Bucket Truck closed.svg";
import EighteenWheelerTruck from "./vehicle-icons/eighteen-wheeler-truck.svg";
import Bulldozer from "./vehicle-icons/Bulldozer.svg";

const svgIcons = {
  AddRowIcon,
  AdminGearIcon,
  AllEventIcon,
  BackwardIcon,
  ButtonIconPlus,
  CallLogsIcon,
  CameraEventSpecCamera,
  CameraEventSpecDriver,
  CameraEventSpecExpiry,
  CameraEventSpecLocation,
  ChartIcon,
  ChartTypePIE,
  ChartTypeDOUGHNUT,
  ChartTypeVERTICAL_BAR_GRAPH,
  ChartTypeHORIZONTAL_BAR_GRAPH,
  ChartTypeSTACKED_BAR_GRAPH,
  ChartTypeLINE_GRAPH,
  ChatIcon,
  ChatAttachmentIcon,
  ChatEmojiIcon,
  ChatImageIcon,
  CheckedIcon,
  Checkbox,
  CheckboxChecked,
  ChevronRight,
  ChevronDown,
  ChevronRightBlue,
  CloseIcon,
  CloseIconGray,
  ColFilterIcon,
  CollapseIcon,
  ConfigurationIcon,
  CrossRedIcon,
  ComplianceIcon,
  Delete,
  Document,
  Download,
  DragHandleBars,
  EditIcon,
  EndLocation,
  EyeOpen,
  ExpandIcon,
  ExpandMoreIcon,
  ExpandWindowIcon,
  Error,
  FastBackwardIcon,
  FastForwardIcon,
  FilterIcon,
  ForwardIcon,
  FullScreenIcon,
  GroupChatIcon,
  GroupFilterIcon,
  HamburgerIcon,
  HandIcon,
  heatmapRouteClickIconAsString,
  HelpIcon,
  HideColumnIcon,
  HidePasswordIcon,
  Hooter,
  Info,
  LeftArrowIcon,
  LineStyleIcon,
  LineStyleIconDefault,
  LineStyleIconP2P,
  LineStyleIconSnap,
  LineStyleIconDirSvc,
  LinkIcon,
  LiveViewIcon,
  LoadingAnimation,
  LockIcon,
  Logo,
  Loading,
  MagnifierIcon,
  MapLayersIcon,
  MapMarkerBlue,
  MapMarkerRed,
  MinimizeIcon,
  MinusBlue,
  MoreVertBlack,
  MoreVertBlue,
  NotificationIcon,
  PlayO,
  PlusBlue,
  PrintIcon,
  RefreshIcon,
  RightArrowIcon,
  RightArrowIcon2,
  RouteEndIconAsString,
  RouteStartIconAsString,
  SearchIcon,
  SendChatMessageIcon,
  SettingIcon,
  ShowImageIcon,
  ShowImageIconBlue,
  ShowPasswordIcon,
  SMSIcon,
  SortColumnsIcon,
  SortIcon,
  StarFilledBlue,
  StarOutline,
  StartLocation,
  Success,
  UnknownTripLocation,
  UpdatesLive,
  UpdatesPaused,
  Upload,
  UsersIcon,
  VideoCameraIcon,
  VideoPlayButton,
  VoiceCallIcon,
  Warning,
  WarningIcon,
  TimerIcon,
  SharedExt,
  SummationIcon,
  ArrowLeftIcon,
  PlayButton,
  RightArrowGrey,
  HelpCenterIcon,
  DetailedHelCenterIcon,
  PhFireTruck,
  HugeTanker,
  HugeTruckMonster,
  RiTruck,
  ForkliftTruck,
  Excavator,
  Van,
  PickupTruck,
  Trailer,
  SanitationTruck,
  EV,
  Tractor,
  TowTruck,
  SkidSteer,
  ConcreteTruck,
  BusFront,
  BusSide,
  CarSide,
  CarFront,
  Backhoe,
  BucketTruckOpen,
  BucketTruckClosed,
  EighteenWheelerTruck,
  Bulldozer,
};

export default svgIcons;
